import styled from 'styled-components'

export const Absolute = styled.div`
  position: absolute;
`
